<ng-container *ngIf="data?.success; else emptyTemplate">
	<ng-container *ngIf="compareData.length; else emptyTemplate">
		<div class="dz-grid margin-top-10">
			<ng-container *ngTemplateOutlet="dataTable; context: { compareDataList: (customAdvisoryFee$ | async) ? compareDataList : grossCompareDataList }"></ng-container>
			<ng-template #dataTable let-compareDataList="compareDataList">
				<div
					class="dz-row data-row d-flex align-items-center"
					*ngFor="let dataPoint of compareDataList?.dataPoints; let i = index"
					[ngClass]="{ 'grey-row': (i + 1) % 2 === 0 }"
				>
					<ng-container *ngTemplateOutlet="dataPointRow; context: { dataPoint: compareDataConfig[dataPoint], dataPointKey: dataPoint }"></ng-container>
				</div>
				<ng-container *ngIf="showOptionalData">
					<div
						class="dz-row data-row d-flex align-items-center"
						*ngFor="let dataPoint of compareDataList?.optionalDataPoints; let i = index"
						[ngClass]="{ 'grey-row': (compareDataList?.dataPoints.length + i + 1) % 2 === 0 }"
					>
						<ng-container *ngTemplateOutlet="dataPointRow; context: { dataPoint: compareDataConfig[dataPoint], dataPointKey: dataPoint }"></ng-container>
					</div>
				</ng-container>
				<ng-template #dataPointRow let-dataPoint="dataPoint" let-dataPointKey="dataPointKey">
					<div
						class="pull-left dz-text-align-left padding-vertical-8 padding-left-8"
						[ngClass]="
							compareData.length === ApplicationConstants.MAX_MODELS_FOR_COMPARISON || (enableAddToCompareModel && compareData.length !== 1)
								? 'dz-col-sm-6'
								: 'dz-col-sm-8'
						"
					>
						<span class="dz-text-14-bold" [dcrHTMLKey]="dataPoint.label?.dcrKey">{{ dataPoint.label?.dcrValue }}</span>
						<dz-icon
							*ngIf="dataPoint?.tooltip"
							type="info-circle"
							class="info-circle color-blk-purple text-14"
							[dz-tooltip]="dataPointTooltip"
							[dz-tooltip-hover]="true"
						></dz-icon>
						<ng-template #dataPointTooltip>
							<span [dcrHTMLKey]="dataPoint?.tooltip?.dcrKey"> {{ dataPoint?.tooltip?.dcrValue }} </span>
						</ng-template>
						<p *ngIf="dataPoint.subText" class="dz-text-14" [dcrHTMLKey]="dataPoint.subText?.dcrKey">{{ dataPoint.subText?.dcrValue }}</p>
						<p
							*ngIf="dataPoint.asOfDateKey"
							class="dz-text-14"
							dcrHTMLKey="MINI_COMPARE_AS_OF_DATE_LABEL"
							[dcrSubstitutions]="{ $asOfDate$: compareData[0]?.[dataPoint.asOfDateKey] }"
						>
							As of $asOfDate$
						</p>
					</div>
					<div
						*ngFor="let model of compareData; index as i"
						class="dz-text-align-right dz-text-14"
						[ngClass]="compareData.length === ApplicationConstants.MAX_MODELS_FOR_COMPARISON || enableAddToCompareModel ? 'dz-col-sm-6' : 'dz-col-sm-8'"
					>
						<!-- innerHTML to render html content for text -->
						<span *ngIf="!dataPoint?.isDcrDriven" [innerHTML]="model?.[dataPoint?.dataKey]"> </span>
						<span *ngIf="dataPoint?.isDcrDriven" [innerHTML]="model?.[dataPoint?.dataKey]" [dcrHTMLKey]="dataPointKey + '_' + model?.[dataPoint?.dataKey]"></span>
						<a *ngIf="dataPoint?.dataKey === 'benchmarkYearToDate'" (click)="scrollToBenchmarkDisclosure(i)">
							<sup>{{ i + 1 }}</sup>
						</a>
						<span *ngIf="dataPoint?.twinPropertyKey"> / {{ model?.[dataPoint?.twinPropertyKey] }} </span>
					</div>
				</ng-template>
			</ng-template>
			<!-- data table disclosure -->
			<div class="dz-row text-condensed-12 dz-text-align-left">
				<div #benchmarkDisclosure>
					<div *ngFor="let model of compareData; index as i" class="dz-flex" [attr.id]="'performance-benchmark-disclosure-' + i">
						<span class="text-condensed-14">{{ i + 1 }}: </span>
						<ac-disclosure class="benchmark-disclosure" [isExpandable]="false" [dcrKey]="model.aladdinTicker + '_DISCLOSURE'"></ac-disclosure>
					</div>
				</div>
				<ac-disclosure [isExpandable]="false" dcrKey="MINI_COMPARE_DATA_TABLE_DISCLOSURE"> </ac-disclosure>
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-template #emptyTemplate>
	<div
		class="d-flex dz-justify-content-center dz-align-items-center margin-top-layout-5"
		[dcrHTMLKey]="compareData.length ? 'MINI_COMPARE_TABLE_DATA_LAYER_ERROR' : 'MINI_COMPARE_TABLE_NO_DATA'"
	>
		No Data Available
	</div>
</ng-template>
